import { render, staticRenderFns } from "./FileDownloadConfirmModal.vue?vue&type=template&id=356ef128&scoped=true"
import script from "./FileDownloadConfirmModal.vue?vue&type=script&lang=js"
export * from "./FileDownloadConfirmModal.vue?vue&type=script&lang=js"
import style0 from "./FileDownloadConfirmModal.vue?vue&type=style&index=0&id=356ef128&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356ef128",
  null
  
)

export default component.exports